import { SVGProps, Ref, forwardRef } from 'react';

export const CardLinesPlusOutlinedSize16Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <g>
                    <path
                        d="M.5 8c0-6.125.938-7 7.5-7s7.5.875 7.5 7h-1.4c0-1.52-.06-2.604-.221-3.4-.157-.777-.384-1.15-.623-1.373-.25-.234-.683-.462-1.558-.616C10.816 2.456 9.631 2.4 8 2.4s-2.816.056-3.698.211c-.875.154-1.307.382-1.558.616-.24.223-.466.596-.623 1.372C1.961 5.396 1.9 6.48 1.9 8s.06 2.604.221 3.4c.157.777.384 1.15.623 1.373.25.234.683.462 1.558.616.882.155 2.067.211 3.698.211V15C1.438 15 .5 14.125.5 8"
                        fill="currentColor"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M12.667 16a3.333 3.333 0 1 0 0-6.667 3.333 3.333 0 0 0 0 6.667m-.7-5.53v1.497H10.47v1.4h1.497v1.503h1.4v-1.503h1.503v-1.4h-1.503V10.47z"
                        fill="currentColor"
                    />
                    <path d="M4 7.3h4v1.4H4z" fill="currentColor" />
                    <path d="M4 6.034v-1.4h8v1.4z" fill="currentColor" />
                </g>
            </g>
        </svg>
    )
);
CardLinesPlusOutlinedSize16Glyph.displayName = 'CardLinesPlusOutlinedSize16Glyph';
